export default {
    azerbaijan: 'آذربایجان',
    brazil: 'برزیل',
    croatia: 'کرواسی',
    emirates: 'امارات',
    europe: 'اروپا',
    france: 'فرانسه',
    georgia: 'گرجستان',
    greece: 'یونان',
    india: 'هند',
    iran: 'ایران',
    italy: 'ایتالیا',
    philippines: 'فیلیپین',
    malaysia: 'مالزی',
    maldives: 'مالدیو',
    russia: 'روسیه',
    spain: 'اسپانیا',
    srilanka: 'سریلانکا',
    thailand: 'تایلند',
    turkey: 'ترکیه',
    china: 'چین',
};
